import { render, staticRenderFns } from "./youth.vue?vue&type=template&id=ffdb954c&scoped=true&lang=pug&"
import script from "./youth.vue?vue&type=script&lang=js&"
export * from "./youth.vue?vue&type=script&lang=js&"
import style0 from "./youth.vue?vue&type=style&index=0&id=ffdb954c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdb954c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VRow})
